<template>
<update-base :stakeholder_type="stakeholder_type">
    <form v-if="payment_helper_shops_status == 'success'" id="submit_form">
        <div class="row">
            <div class="col-12 col-md-6 my-2">
                <div v-for="(shop, index) in payment_helper_shops" :key="index" class="my-3">
                    <div class="form-group form-check">
                        <label class="switch">
                            <input
                                type="checkbox"
                                :id="'checkbox' + shop.id"
                                v-model="form_data[shop.id]"
                                disabled
                            />
                            <span class="slider round"></span>
                        </label>
                        <label
                            :for="'checkbox' + shop.id"
                            class="btn m-0 p-0 text-secondary form-check-label pr-4"
                        >
                            {{ shop.title }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </form>
</update-base>
</template>

        

<script>
import $ from 'jquery';
import { i18n } from '@/plugins/i18n';
import UpdateBase from './components/update-base';
import { mapGetters } from 'vuex';
import { stakeholdersService } from '@/common/api.service';

export default {
    components: {
        UpdateBase,
    },
    data() {
        return {
            form_meta_data: {
                submit_btn_progress: false,
                submit_btn_text: i18n.t('btn.submit_changes'),
            },
            form_data: {},
        };
    },
    methods: {
        get_selected_shops() {
            stakeholdersService.get_selected_shops(this.$route.params.hashid).then((response) => {
                let selected_shops = response.data.data;

                for (let index in selected_shops) {
                    $('#checkbox' + selected_shops[index]).prop('checked', true);
                    this.form_data[selected_shops[index]] = true;
                }
            });
        }
    },
    computed: {
        ...mapGetters('gateway', [
            'payment_helper_shops',
            'payment_helper_shops_status',
        ]),
        stakeholder_type() {
            return this.$route.params.stakeholder_type;
        },
    },
    mounted() {
        this.$store.dispatch('gateway/get_payment_helper_shops').then(() => {
            this.get_selected_shops();
        });
    },
}
</script>
